import { styled } from '@mui/material';
import { Query } from '../../../components/Query';
import { api } from '../../../lib/api';
import { DroitImageTable } from './components/DroitImageTable';

function DroitImageEntries() {
    return (
        <Query queryKey={['droit-image-entries']} apiCall={api.getDroitImageEntries}>
            {(data) => (
                <TableContainer>
                    <DroitImageTable droitImageEntries={data} />
                </TableContainer>
            )}
        </Query>
    );
}

const TableContainer = styled('div')(({ theme }) => ({
    width: '100%',
}));

export { DroitImageEntries };
